// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6cf803df","503":"7f953a4d","551":"bfd89d11","555":"de13d86d","713":"8b109f7e","780":"f0f382e8"}[chunkId] + ".chunk.js";
};